function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var NoteLevelsType;
(function (NoteLevelsType) {
  NoteLevelsType["GLOBAL"] = "GLOBAL";
  NoteLevelsType["SERVICE"] = "SERVICE";
  NoteLevelsType["UNIT"] = "UNIT";
})(NoteLevelsType || (NoteLevelsType = {}));
var ConfigModel = /*#__PURE__*/_createClass(function ConfigModel() {
  _classCallCheck(this, ConfigModel);
  this.apiUrl = void 0;
  this.configUrl = void 0;
  this.translationsUrl = void 0;
  this.sessionKeyAuth = void 0;
  this.sessionKeyTabsShared = void 0;
  this.sessionKeyApp = void 0;
  this.sessionKeyCart = void 0;
  this.sessionKeyPackageCart = void 0;
  this.sessionKeySearchParams = void 0;
  this.sessionKeyCookieLaw = void 0;
  this.sessionKeyCurrency = void 0;
  this.sessionKeyDiscardedRecommendations = void 0;
  this.datePickerMinDateOffset = void 0;
  this.roomsLeftMaxToDisplay = void 0;
  this.offersLeftMaxToDisplay = void 0;
  this.defaultLanguage = void 0;
  this.defaultCountry = void 0;
  this.formatDate = void 0;
  this.formatTime = void 0;
  this.googleApiKey = void 0;
  this.googleReCaptchaKey = void 0;
  this.defaultCurrency = void 0;
  this.currency = void 0;
  this.displayFormatDate = void 0;
  this.displayFormatDateShort = void 0;
  this.displayFormatWeekDay = void 0;
  this.displayFormatDateTime = void 0;
  this.googleAnalyticsTrackingId = void 0;
  this.googleTagManagerContainerId = void 0;
  this.useIndexedGeoUnits = void 0;
  this.useConsentManager = void 0;
  this.useTid = void 0;
  this.tenant = void 0;
  this.affiliate = void 0;
  this.pageToRoute = void 0;
  this.session = void 0;
  this.serviceCharacteristics = void 0;
  this.unitOptions = void 0;
  this.theme = void 0;
  this.traveler = void 0;
  this.headerScrollOffset = void 0;
  this.stickyElementsOffset = void 0;
  this.scrollDuration = void 0;
  this.components = void 0;
  this.scrollOffsets = void 0;
  this.externalParam = void 0;
  this.tracking = void 0;
  this.exactSearchDurationOptions = void 0;
  this.packageSearchDurationOptions = void 0;
  this.outsideElementsContainerId = void 0;
  this.stickySearchOffsetClass = void 0;
  this.forms = void 0;
  this.roundPricesToWholeNumber = void 0;
  this.showCheckoutDocuments = void 0;
  this.filterSortOption = void 0;
  this.summaryComponentParams = void 0;
  this.noteSortingOrder = void 0;
  this.hideTravelerForm = void 0;
  this.enableMoveTicketLogic = void 0;
  this.calendar = void 0;
  this.modalContainerClass = void 0;
  this.availabilityCalendarThreshold = void 0;
  this.payment = void 0;
  this.paxRoomConfig = void 0;
  this.sanitizeConfig = void 0;
  this.internFlightInventories = void 0;
});

export { NoteLevelsType, ConfigModel as default };
//# sourceMappingURL=ConfigModel.js.map
